// extracted by mini-css-extract-plugin
module.exports = {"mTablePersonal":"GeneralTableInfo__mTablePersonal--1ZBec"};